import { BrandColors } from '../theme';

export const toolbarTokens = {
    root: {
        background: BrandColors.surface[0],
        color: BrandColors.surface[700],
        borderColor: BrandColors.surface[0],
        borderRadius: '8px',
        gap: '0.5rem',
        padding: '0.75rem',
    },
};